import { Divider, Input, Modal, Select, Switch } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { FadClassesService } from 'core/http/service/ferramentaAutoria/FadClasses.service';
import Colors from 'enums/Colors';
import useFetch from 'hooks/useFetch';
import { CertificacoesModel } from 'models/certificacoes/CertificacoesModel';
import { FadClassesModel } from 'models/ferramentaAutoria/FadClassesModel';
import { FadCoursesModel, IFadClasseCertificado } from 'models/ferramentaAutoria/FadCoursesModel';
import { FAD_Row1 } from 'pages/ferramentaAutoria/AdminFerramentaAutoria.styled';
import { FerramentaAutoriaContext } from 'pages/ferramentaAutoria/context/FerramentaAutoriaContext';
import { TextDangerouslySetInnerHtml } from 'pages/recursos/recursos-conteudo/RecursosConteudoPage.styled';
import React, { useContext, useEffect, useState } from 'react';
import ReactQuill from 'react-quill';
import styled from 'styled-components';
import { FAD_Button_Primary } from '../FadButtons';
import { FadInformationsExclusiveCourseModel } from 'models/ferramentaAutoria/FadInformationsExclusiveCourseModel';
import { isArray } from 'lodash';
import editorConfig from 'pages/diarioBordo/components/textEditor/editorConfig';

const Styled = {
    Container: styled.div`
        padding: 20px;
        margin-bottom: 50px;
        margin-left: 100px;
        display: flex;
        flex-direction: column;
        background-color: ${Colors.White};
    `,

    ColumnForm: styled.div`
        display: flex;
        flex-direction: column;
        gap: 4px;
    `,

    LabelForm: styled.h3`
        //styleName: Base/Legenda 2;
        font-family: 'Barlow';
        font-size: 14px;
        font-weight: 600;
        line-height: 19.6px;
        text-align: left;
        text-decoration-skip-ink: none;
        color: ${Colors.Blue};
    `,
    LabelForm2: styled.h3`
        //styleName: Base/Legenda 2;
        //styleName: Base/Corpo;
        font-family: 'Barlow';
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        text-align: left;
        text-decoration-skip-ink: none;
        color: #666666;
    `,
};

interface IModalFormCourse {
    open: boolean;
    loading: boolean;
    handleSave: () => void;
    handleEdit: () => void;
    handleHidden: () => void;
    setForm: (value: any) => void;
    form: FadCoursesModel;
    certificados: CertificacoesModel[];
    openEdit?: boolean;
}

const serviceClasses = new FadClassesService();

const ModalFormCourse = ({ open, loading, form, certificados, openEdit, handleSave, handleEdit, handleHidden, setForm }: IModalFormCourse) => {
    const [classes, setClasses] = useState<FadClassesModel[]>([]);
    const [inValid, setValid] = useState<boolean>(false);

    const handleNewDescription = () => {
        const newDescription = new FadInformationsExclusiveCourseModel();
        if (form.informationsExclusives && form.informationsExclusives.length > 0) {
            setForm((prevForm: any) => ({
                ...prevForm,
                informationsExclusives: [...prevForm.informationsExclusives, newDescription],
            }));
        } else {
            setForm((prevForm: any) => ({
                ...prevForm,
                informationsExclusives: [newDescription],
            }));
        }
    };

    const handleNewCertificacao = () => {
        const newCertificacao: IFadClasseCertificado = {
            codigo: -1,
            certificado: new CertificacoesModel(),
            classesDTO: [],
        };

        if (form.certificados && form.certificados.length > 0) {
            setForm((prevForm: any) => ({
                ...prevForm,
                certificados: [...prevForm.certificados, newCertificacao],
            }));
        } else {
            setForm((prevForm: any) => ({
                ...prevForm,
                certificados: [newCertificacao],
            }));
        }
    };

    useFetch(async () => {
        const { data, status } = await serviceClasses.findByFadCoursesCodigoPrivate(form.codigo);

        if (status === 200) {
            setClasses(data);
        }
    }, [open, openEdit]);

    useEffect(() => {
        if (form.name.length > 2 && form.description.length > 2 && form.url.length > 2) {
            return setValid(true);
        }

        setValid(false);
    }, [form]);

    return (
        <Modal
            title={<h1 style={{ fontSize: 26 }}> {openEdit ? 'Editar curso' : 'Criar curso'}</h1>}
            open={open || openEdit}
            onOk={inValid && openEdit ? handleEdit : handleSave}
            okText={openEdit ? 'Salvar edição' : 'Criar curso'}
            cancelText={'Cancelar'}
            maskClosable={false}
            confirmLoading={loading}
            okButtonProps={{
                style: {
                    backgroundColor: inValid ? Colors.Blue : Colors.Grey10,
                },
                disabled: !inValid,
            }}
            onCancel={handleHidden}
        >
            <Styled.ColumnForm style={{ borderTop: '1px solid #F0F0F0', paddingTop: 22 }}>
                <Styled.LabelForm>Nome do curso</Styled.LabelForm>
                <Input
                    showCount
                    value={form.name}
                    maxLength={115}
                    onChange={e => {
                        setForm((prev: any) => ({ ...prev, name: e.target.value }));
                    }}
                    placeholder="Digite o nome do curso"
                    size="large"
                />
            </Styled.ColumnForm>
            <Styled.ColumnForm style={{ borderTop: '1px solid #F0F0F0', paddingTop: 22 }}>
                <Styled.LabelForm>Descrição do curso - principal</Styled.LabelForm>
                <ReactQuill
                    modules={editorConfig.modules}
                    formats={editorConfig.formats}
                    value={form.description}
                    onChange={v => {
                        setForm((prev: any) => ({ ...prev, description: v }));
                    }}
                    placeholder="Digite a descrição do curso"
                    style={{
                        height: '140px',
                        overflow: 'scroll',
                        overflowX: 'hidden',
                        overflowY: 'auto',
                    }}
                />
            </Styled.ColumnForm>
            {form?.hasExclusiveContent && (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                    {form?.informationsExclusives &&
                        form?.informationsExclusives?.length > 0 &&
                        form?.informationsExclusives.map((dados, index) => (
                            <Styled.ColumnForm key={index} style={{ borderTop: '1px solid #F0F0F0', paddingTop: 22 }}>
                                <Styled.LabelForm>Descrição do curso ( {index + 1} )</Styled.LabelForm>
                                <ReactQuill
                                    modules={editorConfig.modules}
                                    formats={editorConfig.formats}
                                    value={dados.text}
                                    onChange={v => {
                                        setForm((prev: any) => {
                                            const updatedInformations = [...prev.informationsExclusives];
                                            updatedInformations[index] = {
                                                ...updatedInformations[index],
                                                text: v,
                                            };
                                            return {
                                                ...prev,
                                                informationsExclusives: updatedInformations,
                                            };
                                        });
                                    }}
                                    placeholder="Digite a descrição do curso"
                                    style={{
                                        height: '140px',
                                        overflow: 'scroll',
                                        overflowX: 'hidden',
                                        overflowY: 'auto',
                                    }}
                                />
                                <Select
                                    allowClear
                                    mode="multiple"
                                    style={{ width: '100%' }}
                                    placeholder="Classes"
                                    size="large"
                                    value={classes
                                        .filter(c => dados.fadClasses.includes(c.codigo))
                                        .map(dc => ({ label: dc.name, value: dc.codigo }))}
                                    onChange={v => {
                                        setForm((prev: any) => {
                                            const updatedInformations = [...prev.informationsExclusives];
                                            updatedInformations[index] = {
                                                ...updatedInformations[index],
                                                fadClasses: isArray(v) ? v : [v],
                                            };
                                            return {
                                                ...prev,
                                                informationsExclusives: updatedInformations,
                                            };
                                        });
                                    }}
                                    options={classes.map(c => ({ label: c.name, value: c.codigo }))}
                                />
                            </Styled.ColumnForm>
                        ))}

                    <FAD_Button_Primary text="Adicionar nova descrição" onClick={handleNewDescription} />
                </div>
            )}
            <Styled.ColumnForm style={{ paddingTop: 10 }}>
                <Styled.LabelForm>URL</Styled.LabelForm>
                <Input
                    addonBefore="/"
                    value={form.url.toLocaleLowerCase().replace(/\//g, '')}
                    showCount
                    maxLength={100}
                    onChange={e => {
                        setForm((prev: any) => ({ ...prev, url: e.target.value.replace(/\//g, '').trim() }));
                    }}
                    placeholder="Digite a url do curso"
                    size="large"
                />
            </Styled.ColumnForm>
            <Styled.ColumnForm style={{ paddingTop: 10 }}>
                <Styled.LabelForm>Tipo de redirecionamento</Styled.LabelForm>
                <Select
                    placeholder="Selecione"
                    value={form.typeRedirect}
                    onChange={value => {
                        setForm((prev: any) => ({ ...prev, typeRedirect: value }));
                    }}
                    options={[
                        { value: 'L', label: 'Login' },
                        { value: 'C', label: 'Cadastro' },
                        { value: 'I', label: 'Ignorar' },
                    ]}
                    size="large"
                />
            </Styled.ColumnForm>
            <Styled.ColumnForm style={{ paddingTop: 10 }}>
                {form?.certificados && form.certificados.length > 0 && (
                    <>
                        {form.certificados.map((cert, index) => (
                            <React.Fragment key={index}>
                                <Styled.LabelForm>Tipo de certificação ( {index + 1} )</Styled.LabelForm>
                                <Select
                                    placeholder="Selecione"
                                    value={cert.certificado.codigo}
                                    onChange={value => {
                                        setForm((prev: FadCoursesModel) => {
                                            const certificado = [...prev.certificados];
                                            certificado[index] = {
                                                ...certificado[index],
                                                certificado: certificados.filter(cf => cf.codigo === value)[0],
                                            };

                                            return {
                                                ...prev,
                                                certificados: certificado,
                                            };
                                        });
                                    }}
                                    options={certificados.map(certificacao => ({
                                        value: certificacao.codigo,
                                        label: certificacao.nome,
                                    }))}
                                    size="large"
                                />
                                <Select
                                    allowClear
                                    mode="multiple"
                                    style={{ width: '100%' }}
                                    placeholder="Classes"
                                    size="large"
                                    value={cert.classesDTO.map(c => c.codigo)}
                                    onChange={(codigosSelecionados: number[]) => {
                                        const novasClasses = classes.filter(c => codigosSelecionados.includes(c.codigo));

                                        setForm((prev: FadCoursesModel) => {
                                            const certificadosAtualizados = [...prev.certificados];
                                            certificadosAtualizados[index] = {
                                                ...certificadosAtualizados[index],
                                                classesDTO: novasClasses,
                                            };
                                            return {
                                                ...prev,
                                                certificados: certificadosAtualizados,
                                            };
                                        });
                                    }}
                                    options={classes.map(c => ({
                                        label: c.name,
                                        value: c.codigo,
                                    }))}
                                />
                                <Divider />
                            </React.Fragment>
                        ))}
                    </>
                )}
                <FAD_Button_Primary
                    text={form?.certificados && form.certificados.length > 0 ? 'Adicionar nova certificação' : 'Adicionar uma certificação'}
                    onClick={handleNewCertificacao}
                />
            </Styled.ColumnForm>
            <FAD_Row1 style={{ marginTop: 10 }}>
                <Switch
                    value={form.sequentialContents}
                    onChange={c => {
                        setForm((prev: any) => ({ ...prev, sequentialContents: c }));
                    }}
                />
                <Styled.LabelForm2>Conteúdos sequências</Styled.LabelForm2>
            </FAD_Row1>
            <FAD_Row1 style={{ marginTop: 10 }}>
                <Switch
                    value={form.sequentialSteps}
                    onChange={c => {
                        setForm((prev: any) => ({ ...prev, sequentialSteps: c }));
                    }}
                />
                <Styled.LabelForm2>Etapas sequências</Styled.LabelForm2>
            </FAD_Row1>
            <FAD_Row1 style={{ marginTop: 10 }}>
                <Switch
                    value={form.hasExclusiveContent}
                    onChange={c => {
                        setForm((prev: any) => ({ ...prev, hasExclusiveContent: c }));
                    }}
                />
                <Styled.LabelForm2>O curso tem partes exclusivas para diferentes turmas ?</Styled.LabelForm2>
            </FAD_Row1>
            <FAD_Row1 style={{ marginTop: 10 }}>
                <Switch
                    value={form.finished}
                    onChange={c => {
                        setForm((prev: any) => ({ ...prev, finished: c }));
                    }}
                />
                <Styled.LabelForm2>O curso está completo ?</Styled.LabelForm2>
            </FAD_Row1>
        </Modal>
    );
};

export default ModalFormCourse;
